import PropTypes from "prop-types";
import * as React from "react";
import { Button, Typography, WarningIcon } from "../../themeV2";
import FilePicker from "./FilePicker";
import ImageSection from "./ImageSection";
import css from "./ShopImagesEditor.module.css";

const HeadshotSection = React.forwardRef(function HeadshotSection(
  { headshot, pending, onFiles, onRecrop, onRetry },
  headingRef,
) {
  return (
    <ImageSection
      id="headshot"
      ref={headingRef}
      title="Headshot"
      description="Shown on the shop page, and in the corner of cards that lead with a character."
      actions={
        <>
          <FilePicker inputLabel="Replace headshot" onFiles={onFiles}>
            Replace
          </FilePicker>
          {headshot?.sourceUrl && (
            <Button variant="text" onClick={() => onRecrop(headshot)}>
              Adjust crop
            </Button>
          )}
        </>
      }
    >
      {headshot ? (
        <img
          className={css.headshotPreview}
          src={headshot.url}
          alt=""
          width={150}
          height={200}
        />
      ) : (
        <Typography variant="body-md" color="variant">
          No headshot yet.
        </Typography>
      )}
      {pending.map((item) => (
        <p key={item.id} className={css.problem}>
          <WarningIcon aria-hidden="true" className={css.inlineIcon} />
          {item.status === "failed" ? item.error : "Uploading…"}
          {item.status === "failed" && (
            <Button variant="text" size="sm" onClick={() => onRetry(item.id)}>
              Retry
            </Button>
          )}
        </p>
      ))}
    </ImageSection>
  );
});

HeadshotSection.propTypes = {
  headshot: PropTypes.shape({
    url: PropTypes.string.isRequired,
    sourceUrl: PropTypes.string,
  }),
  pending: PropTypes.arrayOf(PropTypes.object).isRequired,
  onFiles: PropTypes.func.isRequired,
  onRecrop: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
};

export default HeadshotSection;
